import { render, staticRenderFns } from "./FileTransfer.vue?vue&type=template&id=691a398b&scoped=true&"
import script from "./FileTransfer.vue?vue&type=script&lang=js&"
export * from "./FileTransfer.vue?vue&type=script&lang=js&"
import style0 from "./FileTransfer.vue?vue&type=style&index=0&id=691a398b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691a398b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('691a398b')) {
      api.createRecord('691a398b', component.options)
    } else {
      api.reload('691a398b', component.options)
    }
    module.hot.accept("./FileTransfer.vue?vue&type=template&id=691a398b&scoped=true&", function () {
      api.rerender('691a398b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/support/FileTransfer.vue"
export default component.exports